<template>
	<div class="form-section">
		<h3 class="section-title">Notes</h3>
		<div class="form-group">
			<textarea
				id="invoice-notes"
				:value="modelValue"
				:disabled="disabled"
				@input="$emit('update:modelValue', $event.target.value)"
				class="field-input notes-textarea"
				rows="1"
				placeholder="Add any additional notes, terms, or comments for this invoice..."
			></textarea>
		</div>
	</div>
</template>

<script setup>
defineProps({
	modelValue: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
});

defineEmits(['update:modelValue']);
</script>

<style scoped>
.form-section {
	border-top: none;
	border-radius: 0;
	background-color: transparent;
	padding-top: 0;
	margin-top: 0;
	display: flex;
	flex-direction: column;
	height: 100%;
}

.section-title {
	font-size: 1rem;
	font-weight: 600;
	color: var(--text-color);
	margin: 0 0 8px 0;
	padding-bottom: 0;
	border-bottom: none;
}

.form-group {
	flex: 1;
	display: flex;
	min-width: 200px;
}

.field-input {
	width: 100%;
	padding: 6px 12px;
	border: 1px solid var(--border-color);
	border-radius: 0;
	background: var(--noc-background, #fff);
	color: var(--text-color, #333);
	line-height: 1.5;
	transition: border-color 0.1s ease;
	font-size: 0.85rem;
	font-family: inherit;
	height: 100%;
	box-shadow: none;
}

.field-input::placeholder {
	color: var(--text-color-secondary, #9ca3af);
	opacity: 0.6;
}

.field-input:hover {
	border-color: var(--border-color-active);
}

.field-input:focus {
	border-color: var(--text-color, #333);
}

.notes-textarea {
	resize: vertical;
	min-height: 90px;
}
</style>
